import { combineLatest, Observable, shareReplay } from 'rxjs';
import { traversalState$ } from 'streams/traversals$';
import {
  getStartSetIds,
  toViewpointToolBarProps,
  type ViewpointToolBarState,
} from './toViewpointToolBarProps';
import { componentSelectionReloadBuffered$ } from 'canvas/contextToolBar/componentSelectionReloadBuffered$';
import { loadedState$ } from 'loadedState/loadedState$';
import { sidebarPanel$ } from 'canvas/sidebarPanel/sidebarPanel$';
import { isDiscoverJourney$ } from 'canvas/isDiscoverJourney';
import { components$ } from 'streams/components/components$';
import { map } from 'rxjs/operators';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { locale$ } from 'streams/locale$';
import { uniq } from 'lodash';
import type { ArdoqId } from '@ardoq/api-types';
import { buildComponentRepresentationDataByComponentId } from 'streams/buildComponentRepresentationDataByComponentId';
import type { LoadedStatesState } from 'loadedState/loadedStateOperations';
import { featureContext$ } from 'streams/featureContext$';
import { workspaceAndModel$ } from 'streams/workspaceAndModel$';
import { priorityViewpointIds$ } from 'viewpoints/priorityViewpointIds$';

const getCandidateComponentIds = (
  graphSelection: string[],
  loadedState: LoadedStatesState
): ArdoqId[] =>
  uniq([
    ...graphSelection,
    ...loadedState.loadedStates.flatMap(getStartSetIds),
  ]);

export const viewpointToolBar$: Observable<ViewpointToolBarState> =
  combineLatest({
    graphSelection: componentSelectionReloadBuffered$,
    loadedState: loadedState$,
    sidebarPanel: sidebarPanel$,
    viewpoints: traversalState$,
    isDiscover: isDiscoverJourney$,
    components: components$,
    i18nLocale: i18nLocale$,
    locale: locale$,
    featureContext: featureContext$,
    workspaceAndModel: workspaceAndModel$,
    priorityViewpointIds: priorityViewpointIds$,
  }).pipe(
    map(args =>
      toViewpointToolBarProps({
        ...args,
        componentRepresentationDataByComponentId:
          buildComponentRepresentationDataByComponentId(
            getCandidateComponentIds(args.graphSelection, args.loadedState),
            args.components.byId,
            args.workspaceAndModel
          ),
      })
    ),
    shareReplay({ refCount: true, bufferSize: 1 })
  );
